import { render, staticRenderFns } from "./ContatosAnonimos.vue?vue&type=template&id=1233f8f4&scoped=true"
import script from "./ContatosAnonimos.vue?vue&type=script&lang=js"
export * from "./ContatosAnonimos.vue?vue&type=script&lang=js"
import style0 from "./ContatosAnonimos.vue?vue&type=style&index=0&id=1233f8f4&prod&lang=scss&scoped=true"
import style1 from "./ContatosAnonimos.vue?vue&type=style&index=1&id=1233f8f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1233f8f4",
  null
  
)

export default component.exports